const classicStructure = [
    {
        key: '1',
        small: 25,
        big: 50,
        duration: 20,
    },
    {
        key: '2',
        small: 50,
        big: 100,
        duration: 20,
    },
    {
        key: '3',
        small: 75,
        big: 150,
        duration: 20,
    },
    {
        key: '4',
        small: 100,
        big: 200,
        duration: 20,
    },
    {
        key: '5',
        small: 150,
        big: 300,
        duration: 20,
    },
    {
        key: '6',
        small: 200,
        big: 400,
        duration: 20,
    },
    {
        key: '7',
        small: 300,
        big: 600,
        duration: 20,
    },
    {
        key: '8',
        small: 400,
        big: 800,
        duration: 20,
    },
    {
        key: '9',
        small: 600,
        big: 1200,
        duration: 20,
    },
    {
        key: '10',
        small: 800,
        big: 1600,
        duration: 20,
    },
    {
        key: '11',
        small: 1000,
        big: 2000,
        duration: 20,
    },
    {
        key: '12',
        small: 1200,
        big: 2400,
        duration: 20,
    },
    {
        key: '13',
        small: 1500,
        big: 3000,
        duration: 20,
    },
    {
        key: '14',
        small: 2000,
        big: 4000,
        duration: 20,
    },
    {
        key: '15',
        small: 2500,
        big: 5000,
        duration: 20,
    }
]

export default classicStructure;
